import { render, staticRenderFns } from "./SapphireScreens.vue?vue&type=template&id=0dcf9276&scoped=true"
import script from "./SapphireScreens.vue?vue&type=script&lang=js"
export * from "./SapphireScreens.vue?vue&type=script&lang=js"
import style0 from "./SapphireScreens.vue?vue&type=style&index=0&id=0dcf9276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcf9276",
  null
  
)

export default component.exports